'use client';

import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import { LandingBrandBackground } from '@/components/support-mainnet/landing-brand-background';

/** Gate dot-grid canvas (decorative landing animation), sized to its parent. */
export function HeroJourneyGateBackground() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="dark scheme-dark absolute inset-0 overflow-hidden" data-testid="hero-journey-gate-background"><LandingBrandBackground embedded={true} showAnimation={true} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}